import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😰',
  title: 'Creative Burnout',
  description: 'You spend hours searching YouTube, coaching websites, and social media looking for drills and exercises that somehow fit together.'
}, {
  emoji: '🍃',
  title: 'Lack Of Structure',
  description: 'Your sessions lose flow. You jump from drill to drill and wonder if your players are actually progressing in a logical way.'
}, {
  emoji: '📱',
  title: 'Information Overload',
  description: "You search online and find thousands of conflicting ideas. Everyone teaches something different, and you don't know which system actually works."
}, {
  emoji: '😩',
  title: 'Massive Mental Load',
  description: 'Managing players, planning sessions, organizing practices, and preparing matches leaves you exhausted before training even begins.'
}];
export function PainPoints() {
  return <section className="py-20 bg-navy-950 relative border-t border-navy-800" data-id="element-152">
      <div className="container mx-auto px-4" data-id="element-153">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-154">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-5xl text-white uppercase tracking-wide mb-6" data-id="element-155">
            DOES THIS SOUND FAMILIAR?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-400 font-medium" data-id="element-156">
            You love coaching football, but planning sessions is taking over all
            your free time.
            <br className="hidden md:block" data-id="element-157" />
            If you're a football coach, you've probably experienced one of these
            situations:
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-158">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-900/50 border border-navy-800 rounded-2xl p-8 hover:border-navy-600 transition-colors" data-id="element-159">
              <div className="text-4xl mb-4" data-id="element-160">{point.emoji}</div>
              <h3 className="font-oswald text-2xl text-white uppercase tracking-wide mb-3" data-id="element-161">
                {point.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-162">
                {point.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}